module.exports = __webpack_public_path__ + "img/paneration.7c982b18.svg";